import React, { useEffect, useRef, useState } from 'react';
import './Banner.css';
import ContactButton from '../Button/ContactButton';

const Banner = () => {

  const bannerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.3 }
    );

    if (bannerRef.current) {
      observer.observe(bannerRef.current);
    }

    return () => {
      if (bannerRef.current) observer.unobserve(bannerRef.current);
    };
  }, []);

  return (
    <section 
     ref={bannerRef}
      className={`banner-container ${isVisible ? 'visible' : ''}`}
    >
      <div className="banner-content">
        <div className="banner-text">
          <h2>Vous avez un projet ?</h2>
          <p>
            Une idée en tête ? Un projet innovant à concrétiser<br />
            Construisons-le ensemble ! Notre équipe est là pour vous écouter,
            partager vos ambitions et donner vie à votre projet.
          </p>
        </div>
        <ContactButton />
      </div>
    </section>
  );
};

export default Banner;